/**
 * List component for transactions, managing list content and implementing event handler
 *
 * Properties:
 *
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React from "react";

import VoucherLoginListItem from "./VoucherLoginListItem";

const VoucherLoginsList = (props) => {
  const {
    voucherLogins,
    dispatch,
    filterChangedHandle,
    filter,
    onRemoveVoucherLogin,
    setIndex,
    setInitialized,
    showNotification,
  } = props;
  return (
    <>
      <div
        id="inb-c-main-voucher-logins"
        className="inb-c-listing off-canvas-content"
        data-off-canvas-content=""
        key="inb-c-main-vouchers"
      >
        <br />
        {voucherLogins.map((voucher, index) => {
          return (
            <>
              <VoucherLoginListItem
                voucherLogin={voucherLogins[index]}
                key={index + `_res`}
                index={index}
                filterChangedHandle={filterChangedHandle}
                filter={filter}
                dispatch={dispatch}
                onRemoveVocherLogin={onRemoveVoucherLogin}
                setIndex={setIndex}
                _index={index}
                setInitialized={setInitialized}
                showNotification={showNotification}
              />
            </>
          );
        })}
      </div>
    </>
  );
};
export default VoucherLoginsList;
